import {
  SpoArchitectureNaturesTableResponse,
  SpoArchitectureNaturesTableResponseItem,
} from '@spo/types';
import {
  Cell,
  flexRender,
  getCoreRowModel,
  Row,
  useReactTable,
} from '@tanstack/react-table';
import { columnsArchiNatures } from '../../utils/columns/columns';
import './archi-natures-table.scss';

export const ArchiNaturesTable = ({
  natures,
  setDrawerNatureId,
  removeDeletedNature,
  updateArchitectureData,
}: {
  natures: SpoArchitectureNaturesTableResponse;
  setDrawerNatureId: (natureId: string) => void;
  removeDeletedNature: (natureId: string) => void;
  updateArchitectureData: (productNatureId: number, isEnabled: boolean) => void;
}) => {
  const tableData = useReactTable<SpoArchitectureNaturesTableResponseItem>({
    data: natures,
    columns: columnsArchiNatures(
      setDrawerNatureId,
      removeDeletedNature,
      updateArchitectureData,
    ),
    columnResizeMode: 'onChange',
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <table data-testid="archi-natures-table" className="archi-natures-table">
      <thead
        data-testid="archi-natures_table-header"
        className="archi-natures-table-header"
      >
        {tableData.getHeaderGroups().map((headerGroup) => (
          <tr key={headerGroup.id}>
            {headerGroup.headers.map((header, index) => (
              <th key={`${header.id}-${index}`}>
                {flexRender(
                  header.column.columnDef.header,
                  header.getContext(),
                )}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody
        data-testid="archi-natures_table-body"
        className="archi-natures-table-body"
      >
        {tableData
          .getRowModel()
          .rows.map((row: Row<SpoArchitectureNaturesTableResponseItem>) => (
            <tr key={row.id} data-testid="natures-table-row">
              {row
                .getVisibleCells()
                .map(
                  (
                    cell: Cell<
                      SpoArchitectureNaturesTableResponseItem,
                      unknown
                    >,
                    index,
                  ) => (
                    <td
                      key={`${cell.id}-${index}`}
                      role="gridcell"
                      data-testid={`archi-nature-cell-${row.original.id}`}
                    >
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext(),
                      )}
                    </td>
                  ),
                )}
            </tr>
          ))}
      </tbody>
    </table>
  );
};
